export default {
  home: "/home",
  news: "/news",
  mypage: "/mypage",
  mypageFinancial: "/mypage/financial",
  mypageFinancialEdit: "/mypage/financial/edit",
  mypageBusinessMatching: "/mypage/business-matching",
  mypageResearchTips: "/mypage/research/tips",
  mypageResearchEconomy: "/mypage/research/economy",
  mypageResearchIndustry: "/mypage/research/industry",
  research: "/research",
  researchDetail: "/research/",
  researchSearch: "/research/search",
  researchRelated: "/research/related",
  library: "/library",
  libraryDetail: "/library/casestudy/",
  libraryCaseStudy: "/library/casestudy",
  libraryCaseStudyBusinessMatching: "/library/casestudy/business-matching",
  libraryCaseStudyBusiness: "/library/casestudy/business",
  libraryTrend: "/library/trend",
  librarySuccession: "/library/succession",
  libraryIPO: "/library/ipo",
  libraryMA: "/library/ma",
  libraryFinancialTips: "/library/financial-tips",
  libraryNriReport: "/library/nri-report",
  libraryBusinessReport: "/library/business-report",
  librarySearch: "/library/search",
  businessMatching: "/business-matching",
  businessMatchingSearch: "/business-matching/search/results",
  businessMatchingSettings: "/business-matching/settings",
  businessMatchingCase: "/business-matching/case",
  businessMatchingCaseInbox: "/business-matching/case/inbox",
  businessMatchingCaseRequest: "/business-matching/case/request",
  businessMatchingCaseRequestConfirm: "/business-matching/case/request/confirm",
  businessMatchingCaseRequestDone: "/business-matching/case/request/done",
  businessMatchingCaseRequestNegotiation:
    "/business-matching/case/request/negotiation",
  businessMatchingEntry: "/business-matching/entry",
  businessMatchingEntryCaseNew: "/business-matching/entry/case/new",
  businessMatchingEntryCaseEdit: "/business-matching/entry/case/edit",
  businessMatchingEntryCaseConfirm: "/business-matching/entry/case/confirm",
  businessMatchingEntryCaseDone: "/business-matching/entry/case/done",
  businessMatchingEntryCaseNegotiation:
    "/business-matching/entry/case/negotiation",
  businessMatchingEntryCaseNegotiationConfirm:
    "/business-matching/entry/case/negotiation/confirm",
  businessMatchingEntryCaseNegotiationDone:
    "/business-matching/entry/case/negotiation/done",
  businessMatchingCorporateSearch: "/business-matching/corporate/search",
  businessMatchingFavoriteCorporation:
    "/business-matching/favorite/corporation",
  businessMatchingCorporateHistory: "/business-matching/corporate/history",
  businessMatchingBookmarkUs: "/business-matching/case/favorites",
  businessMatchingCaseHistory: "/business-matching/case/viewed",
  businessMatchingActionSettings: "/business-matching/settings/actions/user",
  search: "/search",
  faq: "/faq",
  settingsCorpProfile: "/settings/corp-profile",
  settingsCorpProfileEdit: "/settings/corp-profile/edit",
  settingsUserProfile: "/settings/user-profile",
  settingsUserProfileEdit: "/settings/user-profile/edit",
  settingsPasswordVerify: "/settings/password/verify",
  settingsPasswordEdit: "/settings/password/edit",
  settingsPasswordDone: "/settings/password/done",
  terms: "/terms",
  policyInquiry: "/policy-inquiry",
  history: "/history",
  pricing: "/pricing",
  policy: "/policy",
  privacyPolicy: "/privacy-policy",
  antisocialForce: "/antisocial-force",
  antisocialStatement: "/antisocial-statement",
  publishedInfo: "/information",
  partner: "/partner",
  notFound: "/404",
  internetError: "/404",
  fourHundred: "/404",
  forbidden: "/403",
  BMForbidden: "/bm-403",
  initialPasswordEdit: "/initial/password/edit",
  initialPasswordDone: "/initial/password/done",
  auth0UnauthorizedReturnTo: "/assets/error/403_forbidden.html",
  pickup: "/pickup",
  initialCompanyInfoEdit: "/initial/corp-profile/edit",
  initialCompanyInfoSalesEdit: "/initial/corp-profile/sales/edit",
  initialCompanyInfoCostEdit: "/initial/corp-profile/cost/edit",
  initialCompanyInfoManagementEdit: "/initial/corp-profile/management/edit",
  initialCompanyInfoConfirm: "/initial/corp-profile/confirm",
  initialCompanyInfoDone: "/initial/corp-profile/done",
  initialUserInfoEdit: "/initial/user-profile/edit",
  initialUserInfoConfirm: "/initial/user-profile/confirm",
  initialUserInfoDone: "/initial/user-profile/done",
  initialRegisterInfoEdit: "/register/register-info/edit",
  initialRegisterInfoConfirm: "/register/register-info/confirm",
  initialRegisterInfoDone: "/register/register-info/done",
  lp: "/",
  lpNews: "/announcements",
  lpNewsDetail: "/announcements/",
  lpTerms: "/legal/terms",
  lpPrivacyPolicy: "/legal/privacy-policy",
  register: "/register",
  confirmAgreement: "/register/confirm-agreement",
  confirmPrivacyPolicy: "/register/confirm-privacy-policy",
  confirmInquiry: "/register/confirm-inquiry",
  entryEdit: "/entry-edit",
  entryConfirm: "/entry-confirm",
  entryDone: "/entry-done",
  confirmSubAgreement: "/confirm-sub-agreement",
  confirmSubPrivacyPolicy: "/confirm-sub-privacy-policy",
  confirmSubInquiry: "/confirm-sub-inquiry",
  information: "/infor",
  informationDetail: "/notice/",
  spotHuman: "/spot-recruitment",
  // 課金-ADD-START
  confirmSubPaymentAgreement:
    "/confirm-sub-business-matching-support-plan-agreement",
  payment: "/premium",
  paymentSelect: "/premium/select-plan",
  paymentAgreement: "/premium/business-matching-support-plan/confirm-agreement",
  paymentComparison: "/premium/free-plan/request/plan-change",
  paymentBillInfo:
    "/premium/business-matching-support-plan/settings/billing-address",
  // 課金-ADD-END
};
